import { EnvManager } from '../utils/EnvManager';

// 获取环境变量管理器实例
const env = EnvManager.getInstance();

// 游戏配置
export const GAME_CONFIG = {
    version: '1.0.0',           // 游戏版本号
    defaultScene: 'start',      // 默认场景
    saveKey: 'cyberpunkGameSave', // 存档键名
    debugMode: import.meta.env.DEV || false, // 在开发环境中启用调试模式
    maxCustomInputLength: 500,  // 自定义输入最大长度
    dialogueTimeout: 10000,     // 对话生成超时时间（毫秒）
    maxRetries: 3,             // 对话生成最大重试次数
    autosaveInterval: 120000,    // 自动保存间隔（毫秒）
    defaultModel: 'gemini-3-flash-preview'  // 默认使用 Gemini3.0Flash（302AI）
};
